/**
 * DG Consigne Automation v2
 * Fonctionne sur TOUTES les pages (global).
 * Détecte les produits consignés via /products/{handle}.js (tags réels).
 * Synchronise la quantité du produit CONSIGNE automatiquement.
 */
(function () {
    'use strict';

    var META = window.DG_CONSIGNE_META || { variantId: 0, sku: 'DG1', tag: 'Consigné' };
    var CONSIGNE_SKU   = META.sku;
    var CONSIGNE_TAG   = META.tag;
    var CONSIGNE_VID   = META.variantId;

    var CART_JS        = '/cart.js';
    var CART_ADD_JS    = '/cart/add.js';
    var CART_CHANGE_JS = '/cart/change.js';

    /* Cache mémoire des tags produit pour éviter des appels répétés */
    var _tagCache = {};  // handle → true/false (est-ce consigné ?)
    var _syncing  = false;
    var _ownCall  = false;  // true pendant nos propres fetch /cart/add ou /cart/change
    var _lastAfterSyncTime = 0;  // timestamp du dernier afterSync (anti-boucle)
    var _syncDebounce = null;    // timer pour le listener dg:cart:updated

    /* ── Extraire le nombre d'unités par item depuis le variant_title ──
     * Supporte les formats multi-facteurs : "Caisse 6×4×250ML" → 24, "Caisse 24×250ML" → 24
     * "Caisse 6×330ML" → 6, "Unité 1UN" → 1, "Pack 12x" → 12
     *
     * Stratégie :
     *   1. Trouver tous les segments numériques "NxN" avant l'unité de volume (mL/ML/L/G/KG)
     *   2. Multiplier ces facteurs entre eux
     *   Ex: "6×4×250ML" → facteurs avant ML = [6, 4] → 6*4 = 24
     *   Ex: "24×250ML"  → facteurs avant ML = [24]   → 24
     *   Ex: "6×330ML"   → facteurs avant ML = [6]    → 6
     *   Ex: "1UN"       → aucun facteur trouvé        → 1
     */
    function getUnitsPerItem(item) {
        var title = (item.variant_title || item.title || '');

        // Chercher le patron NxNxVOLUME_UNIT n'importe où dans le titre
        // Ex: "Caisse 6x4x250ML" → match "6x4x250ML", extraire [6, 4] → 24
        // Ex: "Caisse 24x250ML"  → match "24x250ML",  extraire [24]   → 24
        // Ex: "Caisse 6x330ML"   → match "6x330ML",   extraire [6]    → 6
        // Ex: "Unité 1UN"        → aucun match → 1
        var volumeMatch = title.match(/((?:\d+\s*[x×X]\s*)+)\d+\s*(?:ml|mL|ML|cl|CL|g\b|G\b|kg|KG|L\b|oz|OZ)/i);
        if (volumeMatch) {
            // La portion capturée est "6x4x" ou "24x" ou "6x" — extraire tous les entiers
            var parts = volumeMatch[1].match(/\d+/g);
            if (parts && parts.length > 0) {
                return parts.reduce(function(acc, n) { return acc * parseInt(n, 10); }, 1);
            }
        }

        // Fallback : chercher le premier pattern simple NUMBERx (ex: "Caisse 24x" ou "Pack 12x")
        var simpleMatch = title.match(/(\d+)\s*[x×X]/i);
        if (simpleMatch) return parseInt(simpleMatch[1], 10);

        return 1;
    }

    /* ── Savoir si un produit (par handle) a le tag Consigné ── */
    function isConsigne(handle, cb) {
        if (handle === 'consigne-0-10' || handle === 'consigne') { return cb(false); }
        if (_tagCache[handle] !== undefined) { return cb(_tagCache[handle]); }

        fetch('/products/' + handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) {
                var tags = (p && p.tags) ? p.tags : [];
                // tags est un Array ou une string selon la version
                var tagsArr = Array.isArray(tags) ? tags : String(tags).split(',').map(function(t){return t.trim();});
                var isC = tagsArr.indexOf(CONSIGNE_TAG) !== -1;
                _tagCache[handle] = isC;
                cb(isC);
            })
            .catch(function () {
                _tagCache[handle] = false;
                cb(false);
            });
    }

    /* ── Sync principale ── */
    function syncConsigne() {
        if (_syncing) return;
        if (!CONSIGNE_VID) {
            console.warn('[dgConsigne] Pas de variantId — vérifier all_products[\'consigne-0-10\'] dans theme.liquid');
            return;
        }
        _syncing = true;
        /* NOTE: on ne dispatche PAS syncStart ici.
           On le fait uniquement si un vrai changement consigne est nécessaire,
           pour ne pas locker les boutons inutilement (items sans consigne). */

        fetch(CART_JS)
            .then(function (r) { return r.json(); })
            .then(function (cart) {
                /* Trouver la ligne consigne actuelle */
                var consigneLine = null;
                var regularItems = [];

                cart.items.forEach(function (item) {
                    if (item.sku === CONSIGNE_SKU) {
                        consigneLine = item;
                    } else {
                        regularItems.push(item);
                    }
                });

                if (regularItems.length === 0) {
                    /* Panier vide (hors consigne) → supprimer la consigne si présente */
                    if (consigneLine) {
                        document.dispatchEvent(new CustomEvent('dg:consigne:syncStart'));
                        applyConsigne(consigneLine.key, 0);
                    } else {
                        _syncing = false;
                        /* Pas de changement → pas de syncStart → pas besoin de syncEnd */
                    }
                    return;
                }

                /* Vérifier les tags en parallèle pour chaque item régulier */
                var pending = regularItems.length;
                var consignéQty = 0;

                regularItems.forEach(function (item) {
                    isConsigne(item.handle, function (ok) {
                        if (ok) consignéQty += item.quantity * getUnitsPerItem(item);
                        pending--;
                        if (pending === 0) {
                            /* Toutes les vérifications sont terminées */
                            var currentQty = consigneLine ? consigneLine.quantity : 0;
                            var currentKey = consigneLine ? consigneLine.key : null;

                            if (consignéQty === currentQty) {
                                /* Rien à changer → sortir sans locker les boutons */
                                _syncing = false;
                                return;
                            }

                            /* Un vrai changement est nécessaire → maintenant on locke */
                            document.dispatchEvent(new CustomEvent('dg:consigne:syncStart'));

                            if (consignéQty === 0) {
                                /* Supprimer */
                                if (currentKey) applyConsigne(currentKey, 0);
                                else { _syncing = false; document.dispatchEvent(new CustomEvent('dg:consigne:syncEnd')); }
                            } else if (currentQty === 0) {
                                /* Ajouter */
                                addConsigne(consignéQty);
                            } else {
                                /* Mettre à jour */
                                applyConsigne(currentKey, consignéQty);
                            }
                        }
                    });
                });
            })
            .catch(function (err) {
                console.error('[dgConsigne] Erreur fetch cart:', err);
                _syncing = false;
            });
    }


    function addConsigne(qty) {
        _ownCall = true;
        fetch(CART_ADD_JS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: CONSIGNE_VID, quantity: qty })
        })
        .then(function () { _ownCall = false; afterSync(); })
        .catch(function (err) {
            console.error('[dgConsigne] Erreur add:', err);
            _ownCall = false;
            _syncing = false;
            document.dispatchEvent(new CustomEvent('dg:consigne:syncEnd'));
        });
    }

    function applyConsigne(key, qty) {
        _ownCall = true;
        fetch(CART_CHANGE_JS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: qty })
        })
        .then(function () { _ownCall = false; afterSync(); })
        .catch(function (err) {
            console.error('[dgConsigne] Erreur change:', err);
            _ownCall = false;
            _syncing = false;
            document.dispatchEvent(new CustomEvent('dg:consigne:syncEnd'));
        });
    }

    function afterSync() {
        _lastAfterSyncTime = Date.now();
        _syncing = false;
        document.dispatchEvent(new CustomEvent('dg:consigne:syncEnd'));

        if (window.location.pathname === '/cart') {
            /* Sur la page panier : mettre à jour les items + totaux via Shopify Sections API.
               Pas de reload = scroll préservé, pas de clignotement, aucune boucle. */
            refreshCartSection();
        } else {
            /* Sur les autres pages : mettre à jour le drawer, le badge et les cartes produits */
            if (typeof window.refreshCartState === 'function') {
                window.refreshCartState();
            }
        }
    }

    /* ── Refresh partiel de la page panier via Shopify Sections API ──
       Remplace uniquement #dg-cart-items et .dg-cart-totals (pas le widget Ding Doong etc).
       Utilise document.addEventListener délégué → les event listeners survivent au DOM swap. */
    function refreshCartSection() {
        fetch('/?sections=main-cart-dg')
            .then(function (r) { return r.json(); })
            .then(function (data) {
                var html = data['main-cart-dg'];
                if (!html) return;

                var parser  = new DOMParser();
                var doc     = parser.parseFromString(html, 'text/html');

                /* Sauvegarder la position de scroll de la fenêtre */
                var savedScrollY = window.scrollY;

                /* ── 1. Items list ── */
                var currentItems = document.getElementById('dg-cart-items');
                var newItems     = doc.getElementById('dg-cart-items');
                if (currentItems && newItems) {
                    currentItems.innerHTML = newItems.innerHTML;
                }

                /* ── 2. Totaux (sous-total, taxes, consigne, total) ── */
                var currentTotals = document.querySelector('.dg-cart-totals');
                var newTotals     = doc.querySelector('.dg-cart-totals');
                if (currentTotals && newTotals) {
                    currentTotals.outerHTML = newTotals.outerHTML;
                }

                /* ── 3. Compteur d'articles dans le header ── */
                var currentCount = document.querySelector('.dg-cart__count');
                var newCount     = doc.querySelector('.dg-cart__count');
                if (currentCount && newCount) {
                    currentCount.textContent = newCount.textContent;
                }

                /* ── 4. Restaurer le scroll (requestAnimationFrame pour attendre le paint) ── */
                requestAnimationFrame(function () {
                    window.scrollTo(0, savedScrollY);
                });

                /* ── 5. Mettre à jour aussi le header badge et le drawer ── */
                if (typeof window.refreshCartState === 'function') {
                    window.refreshCartState();
                }
            })
            .catch(function (err) {
                console.error('[dgConsigne] Erreur refreshCartSection:', err);
                /* Fallback seulement si la Sections API échoue */
                window.location.reload();
            });
    }


    /* ── Écoute des événements cart ──
       DÉCLENCHEUR 1 : patchFetch (ci-dessous) — intercepte /cart/add et /cart/change natifs.
       DÉCLENCHEUR 2 : dg:cart:updated — fallback pour les changements de qty dans le drawer.

       Anti-boucle : _lastAfterSyncTime empêche de re-déclencher dans les 2s qui suivent
       notre propre afterSync (ex: afterSync → refreshCartState → dg:cart:updated → skip).
    */
    document.addEventListener('dg:cart:updated', function () {
        /* Ignorer si c'est notre propre afterSync qui a déclenché le refresh */
        if (Date.now() - _lastAfterSyncTime < 2000) return;
        /* Ignorer si un sync est déjà en cours */
        if (_syncing) return;
        /* Dédoublonner via debounce : un seul sync même si l'événement fire plusieurs fois */
        clearTimeout(_syncDebounce);
        _syncDebounce = setTimeout(syncConsigne, 700);
    });

    /* 2. Intercepter les appels /cart/add.js natifs (ajout rapide PDP, quick-view) */
    (function patchFetch() {
        var origFetch = window.fetch;
        window.fetch = function (input, init) {
            var url = typeof input === 'string' ? input : (input && input.url) || '';
            var result = origFetch.apply(this, arguments);
            /* Ignorer nos propres appels internes pour éviter la boucle infinie */
            if (!_ownCall && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1)) {
                result.then(function () {
                    // Laisser le temps au panier de se mettre à jour
                    setTimeout(syncConsigne, 800);
                }).catch(function(){});
            }
            return result;
        };
    })();

    /* ── Init ── */
    function init() {
        syncConsigne();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    window.dgConsigne = { sync: syncConsigne, clearCache: function(){ _tagCache = {}; }, isSyncing: function(){ return _syncing; } };

})();
